module.exports = __webpack_public_path__ + "img/CHECKBOX.4c39dd5c.svg";